import useTournamentStore from './tournamentStore';
import useTeamStore from './teamStore';
import usePlayerStore from './playerStore';
import useMatchStore from './matchStore';
import useFeedbackStore from './feedbackStore';
import useReportStore from './reportStore';

// Re-export the getRandomColor function from playerStore
export { getRandomColor } from './playerStore';

// Create a combined store that provides access to all individual stores
const useStore = () => {
  const tournamentStore = useTournamentStore();
  const teamStore = useTeamStore();
  const playerStore = usePlayerStore();
  const matchStore = useMatchStore();
  const feedbackStore = useFeedbackStore();
  const reportStore = useReportStore();

  return {
    // Tournament
    tournaments: tournamentStore.tournaments,
    activeTournament: tournamentStore.activeTournament,
    tournamentLoading: tournamentStore.loading,
    tournamentError: tournamentStore.error,
    fetchTournaments: tournamentStore.fetchTournaments,
    addTournament: tournamentStore.addTournament,
    updateTournament: tournamentStore.updateTournament,
    deleteTournament: tournamentStore.deleteTournament,
    setActiveTournament: tournamentStore.setActiveTournament,

    // Team
    teams: teamStore.teams,
    teamLoading: teamStore.loading,
    teamError: teamStore.error,
    fetchTeams: teamStore.fetchTeams,
    addTeam: teamStore.addTeam,
    updateTeam: teamStore.updateTeam,
    deleteTeam: teamStore.deleteTeam,

    // Player
    players: playerStore.players,
    playerLoading: playerStore.loading,
    playerError: playerStore.error,
    fetchPlayers: playerStore.fetchPlayers,
    addPlayer: playerStore.addPlayer,
    updatePlayer: playerStore.updatePlayer,
    deletePlayer: playerStore.deletePlayer,
    getPlayer: playerStore.getPlayer,

    // Match
    matches: matchStore.matches,
    activeMatch: matchStore.activeMatch,
    matchLoading: matchStore.loading,
    matchError: matchStore.error,
    fetchMatches: matchStore.fetchMatches,
    createMatch: matchStore.createMatch,
    updateMatch: matchStore.updateMatch,
    deleteMatch: matchStore.deleteMatch,
    updateMatchStatus: matchStore.updateMatchStatus,
    updateScore: matchStore.updateScore,
    setActiveMatch: matchStore.setActiveMatch,

    // Feedback
    feedback: feedbackStore.feedback,
    feedbackLoading: feedbackStore.loading,
    feedbackError: feedbackStore.error,
    fetchFeedback: feedbackStore.fetchFeedback,
    createFeedback: feedbackStore.createFeedback,
    updateFeedback: feedbackStore.updateFeedback,

    // Report
    reports: reportStore.reports,
    reportLoading: reportStore.loading,
    reportError: reportStore.error,
    fetchReports: reportStore.fetchReports,
    createReport: reportStore.createReport,
    updateReportStatus: reportStore.updateReportStatus,

    // Backward compatibility - old loading structure
    loading: {
      tournaments: tournamentStore.loading,
      teams: teamStore.loading,
      players: playerStore.loading,
      matches: matchStore.loading,
      feedback: feedbackStore.loading,
      reports: reportStore.loading,
    },

    // Backward compatibility - old error structure
    error: tournamentStore.error || teamStore.error || playerStore.error || matchStore.error || feedbackStore.error || reportStore.error,
  };
};

export default useStore;
